export const scheduleEventForm = [
	{
		type: 'hidden',
		formControlName: 'id',
	},
	{
		type: 'text',
		title: 'Title (character limit 200)',
		placeholder: 'Enter Title',
		formControlName: 'title',
		required: true,
		maxLength: 200,
		errorsMsg: [
			{ type: 'required', message: 'Title is required' },
			{
				type: 'maxlength',
				message: 'Title should be less than 200 characters',
			},
		],
	},
	{
		type: 'url',
		title: 'Logo(*jpg/jpeg/png)',
		placeholder: 'Enter URL',
		formControlName: 'imageUrl',
		required: true,
		errorsMsg: [
			{ type: 'required', message: 'URL is required' },
			{ type: 'pattern', message: 'Enter a valid URL' },
		],
	},
	{
		type: 'datetime-local',
		title: 'Start Time (Please use your local timezone)',
		placeholder: 'Start Time',
		formControlName: 'startTime',
		required: true,
		errorsMsg: [{ type: 'required', message: 'Start Date is required' }],
	},
	{
		type: 'datetime-local',
		title: 'End Time (Please use your local timezone)',
		placeholder: 'End Time',
		formControlName: 'endTime',
		required: true,
		dateRangeValidator: 'startTime',
		errorsMsg: [
			{ type: 'required', message: 'JobFair End Date is required' },
			{
				type: 'dateRangeValidator',
				message: 'End time is less than start time',
			},
		],
	},
];
